import router from '@/router/index'
import Store from '@/store';

export default {
  changeTitle() {
    let breadCrumbList = router.history.current.meta.breadcrumb;
    let siglaEmpresa = Store.getters.getSiglaEmpresa;

    if (!breadCrumbList) return 'Hexa';
    
    let aux = []
    breadCrumbList.forEach(element => {
      aux.push(element.name)
    });

    document.title ='Hexa :: ' + siglaEmpresa + ' :: ' + aux.join(" > ")
  }
};